const getCurrentPage = () => {
  const pathname = window.location.pathname || "/";
  const page = pathname.split("/").pop() || "index.html";
  return page === "/" ? "index.html" : page.toLowerCase();
};

const buildNavLinks = () => {
  const currentPage = getCurrentPage();

  return [
    { href: "info.html", label: "Nosotros", isCurrent: currentPage === "info.html" },
    {
      href: "index.html",
      label: "Catálogo",
      isCurrent: currentPage === "index.html" || currentPage === "",
    },
    { href: "pedidos.html", label: "Pedidos", isCurrent: currentPage === "pedidos.html" },
    { href: "perfil.html", label: "Mi perfil", isCurrent: currentPage === "perfil.html" },
  ];
};

export const renderHeader = (targetSelector = "#header-root", config = null) => {
  const target = document.querySelector(targetSelector);
  if (!target) return;

  target.__headerAbortController?.abort();
  const controller = new AbortController();
  const { signal } = controller;
  target.__headerAbortController = controller;

  const navLinks = buildNavLinks()
    .map(
      (link) => `
        <li class="main-nav__item">
          <a href="${link.href}" ${link.isCurrent ? 'aria-current="page"' : ""}>${link.label}</a>
        </li>
      `
    )
    .join("");

  const businessName = config?.businessName || "Pizzería";
  const brandTagline = config?.brandTagline || "pizzas y algo más";

  target.innerHTML = `
    <header class="site-header">
      <div class="container header__inner">
        <a class="brand" href="index.html" aria-label="${businessName} - Inicio">
          <img class="brand__icon" src="/icons/icon.svg" alt="" aria-hidden="true" />
          <span class="brand__text">
            <span class="brand__title">${businessName}</span>
            <span class="brand__tagline">&quot;${brandTagline}&quot;</span>
          </span>
        </a>

        <button
          class="nav-toggle"
          type="button"
          aria-label="Abrir menú principal"
          aria-expanded="false"
          aria-controls="site-navigation"
          data-nav-toggle
        >
          <span class="sr-only">Abrir menú principal</span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>

        <nav id="site-navigation" class="main-nav" aria-label="Navegación principal" data-main-nav>
          <ul class="main-nav__list">
            ${navLinks}
          </ul>
        </nav>

        <div class="header__actions">
          <div id="header-auth" class="header-auth" aria-label="Cuenta"></div>
          <button id="cart-toggle" class="header-cart" type="button" aria-label="Ver carrito" aria-expanded="false" aria-controls="cart-drawer-panel">
            <span class="header-cart__icon" aria-hidden="true"><i class="fa-solid fa-cart-shopping"></i></span>
            <span id="cart-count" class="header-cart__count" aria-live="polite" aria-atomic="true">(0)</span>
          </button>
        </div>
      </div>
    </header>
  `;

  const toggle = target.querySelector("[data-nav-toggle]");
  const nav = target.querySelector("[data-main-nav]");

  if (!toggle || !nav) return;

  const closeMenu = () => {
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "Abrir menú principal");
    nav.classList.remove("is-open");
  };

  const openMenu = () => {
    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("aria-label", "Cerrar menú principal");
    nav.classList.add("is-open");
  };

  toggle.addEventListener(
    "click",
    () => {
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        closeMenu();
        return;
      }
      openMenu();
    },
    { signal }
  );

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener(
      "click",
      () => {
        closeMenu();
      },
      { signal }
    );
  });

  target.addEventListener(
    "keydown",
    (event) => {
      if (event.key === "Escape" && nav.classList.contains("is-open")) {
        closeMenu();
        toggle.focus();
      }
    },
    { signal }
  );

  window.addEventListener(
    "resize",
    () => {
      if (window.innerWidth >= 768) {
        closeMenu();
      }
    },
    { signal }
  );
};
